'use strict';

var createReactClass = require('create-react-class'),
	I18nRenderer = require('./helper-i18n-renderer'),
	UnescapedHtml = require('./helper-unescaped-html');

/**
 * I18n Helper
 * @type {Object}
 */

var I18n = {
	I18n: createReactClass({
		render: function () {
			var renderer = new I18nRenderer(this.props);
			if (this.props.unescape) {
				return (<UnescapedHtml markup={renderer.render()} />);
			} else {
				return (<span>{renderer.render()}</span>);
			}
		}
	}),

	helperI18n: function (code, args, argumentsSplitter) {
		var renderer = new I18nRenderer({
			code: code,
			arguments: args,
			argumentsSplitter: argumentsSplitter
		});
		return renderer.render();
	}
};

module.exports = I18n;



// WEBPACK FOOTER //
// ./src/components/utils/helper/helper-i18n.jsx